import goto from "./index";
import getStore from "@utils/redux/store";
import { isNoomSummitEligible } from "@utils/userSegment/features";
import { updateForwardedParams } from "src/utils/urlParams";
import { CHECK_EMAIL_REMINDER_PARAM } from "src/components/collapsible-header/CollapsibleHeader";

export default {
  navigateFromSnackDeliveryCheckout(showEmailReminder = true) {
    const { purchasedSnacks } = getStore().getState().addOns;

    if (purchasedSnacks && isNoomSummitEligible) {
      updateForwardedParams({
        [CHECK_EMAIL_REMINDER_PARAM]:
          purchasedSnacks && showEmailReminder ? "snackDelivery" : null,
      });
      goto.layer("noom-summit");
      return;
    }

    if (purchasedSnacks) {
      goto.enrollment({
        showEmailReminder: "snackDelivery",
      });
      return;
    }

    goto.enrollment({});
  },
};
